import { ResourceOptions } from 'react-admin';
import { FaSlidersH } from 'react-icons/fa';
import { Resources } from '../../resource';

export { default as list } from './List';

export const name = Resources.blindBoxActivityBasic;
export const icon = FaSlidersH;
export const options: ResourceOptions = {
  label: 'module.blindBox.activityBasic',
};
